<template>
    <!-- Zobraz jen na mobilech a když není layout schovaný -->
    <v-bottom-navigation v-if="mobile && !hideLayout" v-model="current" height="64" elevation="8" mode="shift"
        bg-color="rgba(230,230,230,0.85)" class="mobile-bottom-nav">
        <v-btn :to="{ path: '/' }" value="dashboard" variant="text" density="comfortable">
            <v-icon>mdi-calendar-text</v-icon>
            <span>{{ $t('dashboard') }}</span>
        </v-btn>

         <v-btn :to="{ path: '/teams' }" value="teams" variant="text" density="comfortable">
            <v-icon>mdi-account-group</v-icon>
            <span>{{ $t('myTeams') }}</span>
        </v-btn>

        <v-btn :to="{ path: '/leagues' }" value="organizations" variant="text" density="comfortable">
            <v-icon>mdi-trophy</v-icon>
            <span>{{ $t('organizations') }}</span>
        </v-btn>

        <v-btn :to="{ path: myProfileRoute || '/'}" value="profile" variant="text" density="comfortable">
            <v-icon>mdi-account</v-icon>
            <span>{{ $t('profile') }}</span>
        </v-btn>

        
    </v-bottom-navigation>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useDisplay } from 'vuetify';
import { useUserStore } from '@/stores/user/userStore';
import { useRouter } from 'vue-router';

const userStore = useUserStore();
const router = useRouter();
// Převzato z tvého App.vue – stejné chování skrývání layoutu
const route = useRoute();
const hideLayout = computed(() => {
    const hideRoutes = ['/register', '/login', '/special-route', '/password'];
    return hideRoutes.includes(route.path);
});

// Vuetify breakpoint – true na mobilech
const { mobile } = useDisplay();

// Drží aktivní záložku podle route
const routeName = computed(() => (route.name as string) || '');
const current = ref(routeName.value);


const myProfileRoute = computed(() => {
  const user = userStore.user;

  if (!user || !user._id || !user.searchName) {
    return null;
  }

  const searchNameArr = user.searchName.split(' ');
  if (searchNameArr.length < 2) {
    return null;
  }

  return `/users/${user._id}-${searchNameArr[0]}-${searchNameArr[1]}`;
});

// Udržuj v sync s routerem (měníš-li route jinde)
watch(routeName, (n) => (current.value = n));
</script>

<style scoped>
.mobile-bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    color: rgb(var(--v-theme-primary));

    /* iOS safe area */
    padding-bottom: env(safe-area-inset-bottom);

    /* „sklo“ efekt jako ve zbytku UI */
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

/* Jemnější text a ikony */
.mobile-bottom-nav .v-btn {
    text-transform: none;
}

.mobile-bottom-nav .v-icon {
    font-size: 22px;
}

/* Ujisti se, že obsah nad tím má spodní padding */
:global(.has-bottom-nav) {
    padding-bottom: calc(64px + env(safe-area-inset-bottom));
}

/* Fallback: kdyby useDisplay selhalo, schovej na >= sm breakpointu */
@media (min-width: 600px) {
    .mobile-bottom-nav {
        display: none !important;
    }
}
</style>
